import { ApprovedByLeoprinting, ArtWorkReceived, Delivered, ExpectedDispatchDate, FinalProofSent, InProduction, InTransit, NewOrder, Onhold, TemplateRequested, TemplateSent } from "../../routes/production";
import Icon from "@ant-design/icons";
import React from "react";
import { ReactComponent as New_Order } from '../../components/Steps/production-icons/new.svg';
import { ReactComponent as Template_Requested } from '../../components/Steps/production-icons/template-requested.svg';
import { ReactComponent as Template_Sent } from '../../components/Steps/production-icons/template-sent.svg';
import { ReactComponent as Artwork_Received } from '../../components/Steps/production-icons/art.svg';
import { ReactComponent as Final_Proof_Sent } from '../../components/Steps/production-icons/final-proof-sent.svg';
import { ReactComponent as Approved_by_Leoprinting } from '../../components/Steps/production-icons/approved.svg';
import { ReactComponent as On_Hold } from '../../components/Steps/production-icons/hold.svg';
import { ReactComponent as In_Production } from '../../components/Steps/production-icons/in-production.svg';
import { ReactComponent as Expected_Delivery_Date } from '../../components/Steps/production-icons/expected-delivery-date.svg';
import { ReactComponent as In_Transit } from '../../components/Steps/production-icons/transit.svg';
import { ReactComponent as delivered } from '../../components/Steps/production-icons/delivered.svg';


export const ProductionSteps = [
    {
        title: 'New Order',
        icon: <Icon component={New_Order} />,
        status: 1,
        component: () => NewOrder
    },
    {
        title: 'Template Requested',
        icon: <Icon component={Template_Requested} />,
        status: 2,
        component: () => TemplateRequested
    },
    {
        title: 'Template Sent',
        icon: <Icon component={Template_Sent} />,
        status: 3,
        component: () => TemplateSent
    },
    {
        title: 'Artwork Recieved',
        icon: <Icon component={Artwork_Received} />,
        status: 4,
        component: () => ArtWorkReceived
    },
    {
        title: 'Final Proof Sent',
        icon: <Icon component={Final_Proof_Sent} />,
        status: 5,
        component: () => FinalProofSent
    },
    {
        title: 'Approved by Leopriting',
        icon: <Icon component={Approved_by_Leoprinting} />,
        status: 6,
        component: () => ApprovedByLeoprinting
    },
    {
        title: 'On Hold',
        icon: <Icon component={On_Hold} />,
        status: 7,
        component: () => Onhold
    },
    {
        title: 'In Production',
        icon: <Icon component={In_Production} />,
        status: 8,
        component: () => InProduction
    },
    {
        title: 'Expected Delivery date',
        icon: <Icon component={Expected_Delivery_Date} />,
        status: 9,
        component: () => ExpectedDispatchDate
    },
    {
        title: 'In Transit',
        icon: <Icon component={In_Transit} />,
        status: 10,
        component: () => InTransit
    },
    {
        title: 'Delivered',
        icon: <Icon component={delivered} />,
        status: 11,
        component: () => Delivered
    },
]

export const ProductionStatus = {
    1: 'New Order',
    2: 'Template Requested',
    3: 'Template Sent',
    4: 'Artwork Recieved',
    5: 'Final Proof Sent',
    6: 'Approved by Leopriting',
    7: 'On Hold',
    8: 'In Production',
    9: 'Expected Delivery date',
    10: 'In Transit',
    11: 'Delivered'
}

